import { Router, NavigationEnd } from '@angular/router';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CanvasOptionsService } from './core/canvasoptions.service';
import { TranslateService } from '@ngx-translate/core';
import { SlTitleService } from './core/sl-title.service';
import { VersionCheckService } from './core/version-check.service';
import { filter } from 'rxjs';
import { environment } from 'environments/environment';
import { UserService } from './core';
import { UserPermissions } from './shared';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent {
    public canvasControlsExpanded;
    public favicon = document.getElementById('favicon') as HTMLLinkElement;

    private _canViewNewFeatures = this._userService.checkForPermission(UserPermissions.canViewNewFeatures);
    protected sidepanelEnabled = this._canViewNewFeatures && environment.teamworksSidepanelEnabled;

    // eslint-disable-next-line complexity
    constructor(
        private _translate: TranslateService,
        private _router: Router,
        private _canvasControls: CanvasOptionsService,
        private _titleService: SlTitleService,
        private _versionCheckService: VersionCheckService,
        private _userService: UserService
    ) {
        // Sidepanel CSS variables on root for use across components
        // @TODO: This will need to be moved in the callback of the BE request after authenticating a user, because
        // the sidepanel colors will be dynamic based on the current user's organization
        document.documentElement.style.setProperty('--tw-sidepanel-bg-color', '#000');
        document.documentElement.style.setProperty('--tw-sidepanel-bg-accent', '#1a6aff');

        // Switch the favicon based on the environment
        if ( !!this.favicon && !environment.production ) {
            if ( !environment.simulateLive ) {
                // Local Environment
                this.favicon.href = '/assets/projects/sportlogiqwebapp-v2/favicons/favicon_local.ico';
            } else {
                // QA Environment
                this.favicon.href = '/assets/projects/sportlogiqwebapp-v2/favicons/favicon_qa.ico';
            }
        }

        this._versionCheckService.init();

        this.canvasControlsExpanded = false;
        this._translate.addLangs(['en', 'fr']);
        this._translate.setDefaultLang('en');

        const browserLang = this._translate.getBrowserLang();
        this._translate.use(browserLang.match(/en|fr/) ? browserLang : 'en');

        this._canvasControls.canvasExpanded$.subscribe(event => {
            this.canvasControlsExpanded = event;
        });

        this._router.events.pipe(
            filter(e => e instanceof NavigationEnd)
        ).subscribe(() => {
            this._titleService.setTitle();
        });
    }
}
